import { UseQueryResult } from "@tanstack/react-query";
import { withErrorBoundary } from "app/ErrorBoundary/ErrorBoundaryDashboard";
import { AffectedTrainsResponse } from "features/CenterContent/RoleContent/Vaktleder/types";
import { AffectedTrainsContent } from "features/VehicleSidebar/AffectedTrains/AffectedTrainsContent";
import { useAffectedTrainsWebsocket } from "features/VehicleSidebar/AffectedTrains/useAffectedTrainsWebsocket";
import { CreateTrainInfoBatchModal } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/CreateTrainInfoBatchModal";
import { FC } from "react";

type AffectedTrainsProps = {
  affectedTrainsResult: UseQueryResult<AffectedTrainsResponse>;
};

const AffectedTrains: FC<AffectedTrainsProps> = ({ affectedTrainsResult }) => {
  const { data, isPending, isSuccess, isError, refetch } = affectedTrainsResult;

  useAffectedTrainsWebsocket({
    isSuccess,
    affectedTrainsData: data,
    refetch,
  });

  return (
    <AffectedTrainsContent
      data={data}
      isPending={isPending}
      isSuccess={isSuccess}
      isError={isError}
      refetch={refetch}
      renderModal={({
        modalOpen,
        setModalOpen,
        affectedTrainsData,
        selectedTrains,
        updateSelectedTrains,
        addPendingTrains,
      }) =>
        modalOpen &&
        affectedTrainsData &&
        selectedTrains.length > 0 && (
          <CreateTrainInfoBatchModal
            selectedTrains={selectedTrains}
            setModalOpen={setModalOpen}
            updateSelectedTrains={updateSelectedTrains}
            addPendingTrains={addPendingTrains}
          />
        )
      }
    />
  );
};

export default withErrorBoundary(AffectedTrains);
